<fui-page>
    <fui-page-pane>
        <file-upload (onCancel)="onCancel()" (onConfirm)="importFile($event)" [fileExtension]="'.csv'" [fileType]="null"></file-upload>
        <fui-page-header [description]="'wbo.app-layout-file-import.import.description'" [hasToggle]="false"
                         [title]="'wbo.app-layout-file-import.import.title'">
        </fui-page-header>
        <fui-page-body>
            <fui-page-main>
                <fui-page-subject>
                    <fui-rows *ngIf="importing">
                        <fui-row>
                            <fui-two-columns>
                                <fui-column>
                                    <fui-inline-information [messageParams]="{'percentage': percentageComplete}"
                                                            [message]="'wbo.file-import.import.status.processing.message'"
                                                            [title]="'wbo.file-import.import.status.processing.title'"></fui-inline-information>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                        <fui-row>
                            <fui-two-columns>
                                <fui-column>
                                    <fui-ellipsis-loader></fui-ellipsis-loader>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                    </fui-rows>
                    <fui-rows *ngIf="!importing && started">
                        <fui-row>
                            <fui-two-columns>
                                <fui-column *ngIf="success">
                                    <fui-inline-success [message]="'wbo.file-import.import.status.success.message'"
                                                      [title]="'wbo.file-import.import.status.success.title'"></fui-inline-success>
                                </fui-column>
                                <fui-column *ngIf="!success && !errorImporting">
                                    <fui-inline-error [message]="'wbo.file-import.import.status.failed.message'"
                                                            [title]="'wbo.file-import.import.status.failed.title'">
                                        <a (click)="retry()"  href="#"
                                           onclick="return false;">{{'wbo.file-import.import.message.retry' | translate}}</a>
                                    </fui-inline-error>
                                </fui-column>
                                <fui-column *ngIf="!success && errorImporting">
                                    <fui-inline-error [message]="'wbo.file-import.import.status.failedImportingFile.message'"
                                                      [title]="'wbo.file-import.import.status.failedImportingFile.title'">
                                        <a (click)="retry()"  href="#"
                                           onclick="return false;">{{'wbo.file-import.import.message.retry' | translate}}</a>
                                    </fui-inline-error>
                                </fui-column>
                            </fui-two-columns>
                        </fui-row>
                    </fui-rows>
                </fui-page-subject>
            </fui-page-main>
        </fui-page-body>
    </fui-page-pane>
</fui-page>
